import styled from 'styled-components'
// @ts-ignore
import FormField from 'shared/newFormElements'

export const StyledDatePicker = styled(FormField)`
  position: relative;

  .DayPickerInput-Overlay {
    position: absolute;
    top: -33px;
    transform: translate(0, -100%);
  }
`
